import React from "react";
import "./styles.css";

const HourGlass = () => {
    return (
        <img className="imgstyle" alt="An hour glass" src={require("../../../assets/wait.png")} />
    );
}

export default React.memo(HourGlass);